export const handleClickUrl = (event: any) => {
  const target = event.target as HTMLElement;

  if (target.tagName === "A") {
    event.preventDefault();

    const url = (target as HTMLAnchorElement).href;
    openUrl(url);
  }
};

export const openUrl = (url: string) => {
  try {
    const messageData = {
      WebViewLink: {
        URL: url,
        Engine: 'Browser',
        Method: 'Get',
      },
    };
    window.parent.postMessage({ type: "Launch", data: messageData }, "*");
  } catch (error) {
    console.error('postMessage error', error);
  }
};

export const openPortal = () => {
  try {
    const messageData = {
      PortalAppLink: {
        CustomerURL: "mebukug102016://mebukuapp-host/mypage"
      },
    };
    window.parent.postMessage({ type: "Launch", data: messageData }, "*");
  } catch (error) {
    console.error('postMessage error', error);
  }
}

export const getPersonalBasicInfo = () => {
  try {
    window.parent.postMessage({ type: "GetPersonalBasicInfo" }, "*");
  } catch (error) {
    console.error('postMessage error', error);
  }
}
